import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { useAppDispatch } from '../../../../redux/store';
import { commonComponentsRegistry } from '../../../../registry/CommonRegistry';

const JRCButton = commonComponentsRegistry.getLazyComponent('Button');
const JRCInputText = commonComponentsRegistry.getLazyComponent('InputText');

export const CSSWrapper = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    display: flex;
    flex-direction: row;
    fieldset {
        margin: 0.2rem !important;
    }
`;

export const WidgetInlineInputText = ({
    placeholder,
    handleClick,
}: {
    placeholder: string;
    handleClick: (label: string) => void;
}) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const [label, setLabel] = useState<string>('');

    const { control, watch, reset } = useForm({
        defaultValues: { label },
        criteriaMode: 'all',
    });

    useEffect(() => {
        const subscription = watch((data) => {
            setLabel(data.label ?? '');
        });
        return () => subscription.unsubscribe();
    }, [watch, dispatch]);

    return (
        <CSSWrapper>
            <JRCInputText name={'label'} control={control} placeholder={placeholder} width="100%" />
            <JRCButton
                label={intl.formatMessage({ id: 'GLOBAL_Confirm' })}
                disabled={!label.length}
                onClick={() => {
                    handleClick(label);
                    setLabel('');
                    reset();
                }}
            />
        </CSSWrapper>
    );
};
